import React, { memo, useState } from "react";
import { getUserNameInitials } from "../utils/functions/admin_page_functions";

const DELETED_USER_BACKGROUND =
	"linear-gradient(180deg, rgba(180, 180, 180, 0.4) -18.38%, rgba(150, 150, 150, 0.4) 108.82%)";

const DEFAULT_BACKGROUND = "rgba(81, 114, 234, 0.4)";

const UserImage = ({
	userData,
	size = "30px",
	fontSize = "13px",
	color = "var(--color-text-primary)",
	fontWeight = 600,
	background = null,
	backgroundClass = "",
	isButton = false,
	border = null,
}) => {
	const isDeleted = userData?.user_type === "deleted";
	// A stored photo can be gone from the server (404); the initials stand in for it.
	const [failedImage, setFailedImage] = useState(null);
	const showImage = !!userData?.user_image && failedImage !== userData.user_image;
	const userInitials = getUserNameInitials(userData?.user_name, userData?.user_second_name);

	const wrapperStyle = {
		minWidth: size,
		maxWidth: size,
		height: size,
		fontSize,
		color,
		fontWeight,
		...(!backgroundClass && {
			background: isDeleted ? DELETED_USER_BACKGROUND : background || DEFAULT_BACKGROUND,
		}),
		...(border && { border }),
	};

	return (
		<div
			className={`flex justify-center items-center rounded-full overflow-hidden${isButton ? " cursor-pointer transition-[0.2s] hover:[box-shadow:rgba(0,0,0,0.16)_0px_3px_6px,rgba(0,0,0,0.23)_0px_3px_6px]" : ""} ${backgroundClass}`}
			style={wrapperStyle}
		>
			{isDeleted ? (
				<p data-testid="user-image-deleted">×</p>
			) : showImage ? (
				<img
					className="w-full h-full object-cover"
					src={userData.user_image}
					alt=""
					onError={() => setFailedImage(userData.user_image)}
					data-testid="user-image"
				/>
			) : (
				<p data-testid="user-image-initials">{userInitials}</p>
			)}
		</div>
	);
};

export default memo(UserImage);
